import { BUSHA_AUTH_API_URL, BUSHA_GATEWAY_URL } from "app/constants/variables";
import BushaAsset from "app/models/bushaAsset";
import request from "../request";
import { BaseResponse, GenericResponse } from "../types";
import {
  FinalizeTransferPayload,
  GetPaymentConfigResponse,
  InitializeTransferPayload,
  InitializeTransferResponse,
  LoginConfirmPayload,
  LoginPayload,
  LoginResponse,
  SocialLoginPayload,
  ValidateDestinationPayload,
  ValidateDestinationResponse,
} from "./types";
import { getDeviceId, getDeviceName } from "app/lib/device";
import { Balance } from "app/models/balance";

export const login = async (data: LoginPayload) => {
  const deviceInfo = {
    "Device-Id": await getDeviceId(),
    "Device-Name": getDeviceName(),
  };

  return request.post<LoginResponse>("login", data, {
    baseURL: BUSHA_AUTH_API_URL,
    headers: {
      ...deviceInfo,
    },
  });
};

export const socialLogin = async ({ provider, ...data }: SocialLoginPayload) => {
  const deviceInfo = {
    "Device-Id": await getDeviceId(),
    "Device-Name": getDeviceName(),
  };

  return request.post<GenericResponse<LoginResponse>>(`auth/social/${provider}`, data, {
    baseURL: BUSHA_AUTH_API_URL,
    headers: {
      ...deviceInfo,
    },
  });
};

export const loginConfirm = async (payload: LoginConfirmPayload) => {
  const { code, token } = payload;

  const deviceInfo = {
    "Device-Id": await getDeviceId(),
    "Device-Name": getDeviceName(),
  };

  return request.post<LoginResponse>(
    "/auth/confirm",
    { confirmation_code: code },
    {
      baseURL: BUSHA_AUTH_API_URL,
      headers: {
        Authorization: `Bearer ${token}`,
        ...deviceInfo,
      },
    }
  );
};

export const getAssets = (accessToken: string) => {
  return request.get<GenericResponse<BushaAsset[]>>("v1/accounts", {
    baseURL: BUSHA_GATEWAY_URL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
export const getBalances = (accessToken: string) => {
  return request.get<GenericResponse<Balance[]>>("v1/balances", {
    baseURL: BUSHA_GATEWAY_URL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const getPaymentConfig = (accessToken: string) => {
  return request.get<GetPaymentConfigResponse>("me/pay_config", {
    baseURL: BUSHA_AUTH_API_URL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const validateDestination = (
  accessToken: string,
  payload: ValidateDestinationPayload
) => {
  return request.get<ValidateDestinationResponse>(`/v1/payout/destination`, {
    params: payload,
    baseURL: BUSHA_GATEWAY_URL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const initializeTransfer = (
  accessToken: string,
  payload: InitializeTransferPayload
) => {
  return request.post<InitializeTransferResponse>(
    `/v1/payout/initialize`,
    payload,
    {
      baseURL: BUSHA_GATEWAY_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const finalizeTransfer = (
  accessToken: string,
  payload: FinalizeTransferPayload
) => {
  return request.post<InitializeTransferResponse>(
    `/v1/payout/finalize`,
    payload,
    {
      baseURL: BUSHA_GATEWAY_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const resendTransferCode = (
  accessToken: string,
  transferToken: string
) => {
  return request.post<BaseResponse>(
    `/v1/payout/resend`,
    {
      token: transferToken,
    },
    {
      baseURL: BUSHA_GATEWAY_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};
